import { render, staticRenderFns } from "./ImportCustomer.vue?vue&type=template&id=69aefaa2&"
import script from "./ImportCustomer.vue?vue&type=script&lang=js&"
export * from "./ImportCustomer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports